import { normalizeIdentifier, stripAccents } from '@cpce/shared';
import { Decimal } from 'decimal.js';

const priceFormat = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

function normalizeString(value: string) {
  return stripAccents(value).toLowerCase();
}

export function isMatchingFilter(value: string, filter: string) {
  const normalizedValue = normalizeString(value);
  const normalizedFilter = normalizeString(filter);
  return normalizedValue.includes(normalizedFilter);
}

// Rounded first and -0 folded to 0: Intl prints a Decimal -0, or -0.001, as « -0,00 € ».
export function toRoundedCents(value: Decimal.Value): number {
  return new Decimal(value).toDecimalPlaces(2).toNumber() || 0;
}

// fr-FR groups thousands with a narrow no-break space, which the app font draws almost zero-width.
export function widenGroupSeparator(formatted: string): string {
  return formatted.replaceAll('\u202f', '\u00a0');
}

export function formatDecimalAsPrice(value: Decimal.Value): string {
  return widenGroupSeparator(priceFormat.format(toRoundedCents(value)));
}

export function slugify(value: string): string {
  if (!value) return '';

  return stripAccents(value.toLowerCase())
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function formatSiret(siret: string | null): string {
  if (!siret) return '-';
  return siret.replace(/(\d{3})(\d{3})(\d{3})(\d{5})/, '$1 $2 $3 $4');
}

export function formatIban(iban: string): string {
  return normalizeIdentifier(iban)
    .replace(/(.{4})/g, '$1 ')
    .trim();
}
